import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CmsConfig, provideDefaultConfig, UrlModule } from '@spartacus/core'
import { SpinnerModule } from '@spartacus/storefront'
import { UserPermissionsGuard } from '../../../../../guards/user-permissions.guard'
import { SharedModule } from '../../../../shared/shared.module'
import { ShipmentCreditClaimsHistoryComponent } from './shipment-credit-claims-history.component'

@NgModule({
  declarations: [ShipmentCreditClaimsHistoryComponent],
  imports: [CommonModule, UrlModule, SharedModule, SpinnerModule, RouterModule],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        ShipmentCreditClaimHistoryComponent: {
          component: ShipmentCreditClaimsHistoryComponent,
          guards: [UserPermissionsGuard]
        }
      }
    } as CmsConfig)
  ]
})
export class ShipmentCreditClaimsHistoryModule {}
